export const handleWelcome = (message, type) => async (dispatch) => {
  dispatch({ type: "HIDE_WELCOME" });
  dispatch({
    type: type ? "SHOW_WELCOME" : "HIDE_WELCOME",
    payload: message,
  });
};

export const handleInfo = (message, type) => async (dispatch) => {
  dispatch({ type: "HIDE_INFO" });
  dispatch({
    type: type ? "SHOW_INFO" : "HIDE_INFO",
    payload: message,
  });
};

export const handleError = (message, type) => async (dispatch) => {
  dispatch({ type: "HIDE_ERROR" });

  dispatch({
    type: type ? "SHOW_ERROR" : "HIDE_ERROR",
    payload: message,
  });
};

export const closeNotification = () => async (dispatch) => {
  dispatch({
    type: "CLOSE_NOTIFICATION",
  });
};
